import FingerprintJS from '@fingerprintjs/fingerprintjs';

// reference: https://fingerprint.com/github/
const fpPromise = FingerprintJS.load();
let cachedFingerprint = null;
// Get the visitor identifier when you need it.
export const getFingerprint = async () => {
  if (cachedFingerprint) {
    return Promise.resolve(cachedFingerprint);
  }
  return new Promise((resolve, reject) => {
    fpPromise
      .then((fp) => fp.get())
      .then((result) => {
        cachedFingerprint = result;
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
  });
};

export const reportEvent = async (url, eventInfo) => {
  try {
    const body = {
      eventInfo: { ...eventInfo, source: 'rc2.0' },
      eventName: 'claim_submission',
      eventSourceName: 'resolution_center_fe_report',
    };
    // console.log('body', body);
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
      },
    }).catch((e) => {
      console.log('REPORT EVENT ERROR', e.message);
    });
  } catch (error) {
    console.log('REPORT EVENT ERROR', error.message);
  }
};
